document.addEventListener('DOMContentLoaded', function() {

     if(sessionStorage.latitude && sessionStorage.continent_code){
    checkRegionReminder();
    showBanner(sessionStorage);
      } else{
        sessionStorage.country_popup = "yes"
        fetch('https://api.ipstack.com/check?access_key=d80994ea081160066e2740ea91b25ed0&format=1&fields=country_name,country_code,continent_code,latitude,longitude')
        .then(response => {
          if (!response.ok) {
           console.error('api.ipstack.com throw an error')
          }
          return response.json();
        })
        .then(data => {
            sessionStorage.country_code = data.country_code;
            sessionStorage.country_name = data.country_name;
            sessionStorage.continent_code = data.continent_code;
            sessionStorage.latitude = data.latitude;
            sessionStorage.longitude = data.longitude;
          
           checkRegionReminder();
           showBanner(data);
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
      }
  
});

function checkRegionReminder(){

  var button = document.getElementById('mezeRegionReminder');
   var currentHostname = window.location.hostname;
     var currentPathname = window.location.pathname;
     var currentParams = '?';

     if(sessionStorage._ef_transaction_id){
       currentParams += '_ef_transaction_id='+ sessionStorage._ef_transaction_id+'&';
     }

     if(sessionStorage.oid){
       currentParams += 'oid='+ sessionStorage.oid+'&';
     }

     if(sessionStorage.affid){
       currentParams += 'affid='+ sessionStorage.affid+'&';
     }
  
  if(button){
    if (sessionStorage.continent_code == "EU" && currentHostname.includes('.com')) {
       var targetURL = 'https://' + currentHostname.replace('.com', '.eu') + currentPathname + currentParams;
       var message = 'You are browsing our International site, for shipping inside of the EU, please switch to our European website';
       showRegionReminder(targetURL,message, button);
    }

     if (sessionStorage.continent_code != "EU" && currentHostname.includes('.eu')) {
       var targetURL = 'https://' + currentHostname.replace('.eu', '.com') + currentPathname + currentParams;
        var message = 'You are browsing our European site, for shipping outside of the EU, please switch to our International website';
       showRegionReminder(targetURL,message, button);
     
    }
    
   }
}


function showBanner(data) {

      if(sessionStorage.country_popup !== "yes"){
        return;
      }

      if (window.location.href !== 'https://mezeaudio.eu/') {
         return;
      }
  
      var barHtml = '', link='', btitle ='';
      
      switch(data.country_code){
        case "CN" : barHtml = "<p class='main-text-pop'>It looks like you're visiting us from China, you can visit our chinese website. &ensp; <a href='http://mezeantonio.cn/' style='font-weight:normal; border:solid 1px;border-color:white; background-color:transparent; padding: 5px 10px 5px 10px' class='btn btn-primary btn-outline'> Visit here </a></p>";
                    break;
        case "RO" : barHtml = "<p class='main-text-pop'>Dac&#259; e&#351;ti din Rom&#226;nia, po&#x163;i cump&#259;ra produse Meze Audio &#351;i le po&#x163;i pl&#259;ti prin ramburs <a href='https://mezeaudio.eu/pages/livrare-ramburs' style='font-weight:normal; border:solid 1px;border-color:white; background-color:transparent; padding: 5px 10px 5px 10px' class='btn btn-primary btn-outline'>Mai mult</a></p>";
                    break;
        case "CA" : barHtml = "<p class='main-text-pop' style=' font-size: 13px;'>It looks like you're visiting us from Canada, where we have a <a href='/pages/dealers'> distributor and local shops</a>. &ensp; <a href='mailto:info@eriksonconsumer.com' style='font-weight:normal; border:solid 1px;border-color:white; background-color:transparent; padding: 5px 10px 5px 10px' class='btn btn-primary btn-outline' target='_blank'>Contact Erikson Consumer </a></p>";
                    break;  
        case "FR" : barHtml = "<p class='main-text-pop'>Il semble que vous nous rendiez visite depuis la France. Veuillez consulter notre site &ensp; <a href='https://mezeaudio.fr/' style='font-weight:normal; border:solid 1px;border-color:white; background-color:transparent; padding: 5px 10px 5px 10px' class='btn btn-primary btn-outline'> Web français</a></p>";
                    break;  
        case "DE":
          link = "https://headphone.shop/";
          btitle = "headphone.shop";
          break;
        case "GB":
          link = "http://www.scvdistribution.co.uk/category/meze-audio";
          btitle = "SCV Distribution";
          break;
        case "NL":
        case "BE":
        case "LU":
        case "DK":
        case "SW":
          link = "http://www.duneblue.com/dealers";
          btitle = "DuneBlue";
          break;
        case "NO":
          link = "http://www.njal.no/";
          btitle = "Njål Hansson AS";
          break;
        case "RU":
          link = "https://blade.ru/brands/meze";
          btitle = "Blade";
          break;
        case "AU":
          link = "https://www.radianceav.com.au";
          btitle = "Radiance Audio Visual";
          break;
        case "HK":
          link = "https://soundwaveaudio.com.hk/category/brands/meze-audio/";
          btitle = "Soundwave Audio";
          break;
        case "TR":
          link = "https://extreme-audio.com";
          btitle = "Extreme Audio";
          break;
        case "IN":
          link = "https://www.headphonezone.in";
          btitle = "Headphone Zone";
          break;  
        case "HU":
        case "SK":
          link = "https://www.basys.co/meze";
          btitle = "Basys";
          break;  
        case "JP":
          link = "https://kanjitsu.com";
          btitle = "Kanjitsu Denki Co. Ltd.";
          break;  
        case "NZ":
          link = "https://bit.ly/3iiCle2";
          btitle = "Capisco Limited";
          break;  
      }

       if(barHtml==='' && link!=='' && btitle!==''){
        barHtml = "<p class='main-text-pop'>It looks like you're visiting us from "+data.country_name+", where you have a local distributor. &ensp; <a href='"+link+"' style='font-weight:normal; border:solid 1px;border-color:white; background-color:transparent; padding: 5px 10px 5px 10px' class='btn btn-primary btn-outline' target='_blank'>Visit "+btitle+"</a></p>";
      }
  
      setTimeout(function () {
            if(barHtml!==''){
               document.getElementById('meze-country-message').innerHTML = barHtml;
               document.getElementById('meze-country-bar').style.display = 'flex';
      
              document.getElementById('meze-country-close').addEventListener("click", function() {
                  document.getElementById('meze-country-bar').style.display = 'none';
                  sessionStorage.country_popup = "no";
              });
          }
      }, 5000);

}

function showRegionReminder(targetURL,message, targetElement){

   switchStore = ' <div class="product-info__button"><a href="'+targetURL+'" <button type="button" class="button button--sm w-full" style="background-color: #f0eeeb; color: #17120f; font-size:11pt" is="custom-button"><div>'+message+'</div><span class="button__loader">     <span></span>  <span></span>  <span></span>   </span></a></button></div>';
 
   targetElement.insertAdjacentHTML('afterend',switchStore);
  
}